export default
{
    /**
     * Round a number to specified precision.
     * Rounds away from zero.
     *
     * @param {number} num
     * @param {number} decimals
     * @returns {number}
     */
    round(num, decimals)
    {
        const sign = Math.sign(num);
        const e = Math.pow(10, parseInt(decimals) || 0);

        return sign * Math.round(Math.abs(num + Number.EPSILON) * e) / e;
    },

    roundToMultiple(num, multiple)
    {
        return Math.round(num / multiple) * multiple;
    },

    ceilToMultiple(num, multiple)
    {
        return Math.ceil(num / multiple) * multiple;
    },

    floorToMultiple(num, multiple)
    {
        return Math.floor(num / multiple) * multiple;
    },

    /**
     * Removes trailing `0` decimals, as well as any trailing dot.
     *
     * @param {number|string} num
     * @returns {string}
     */
    removeZeroDecimals(num)
    {
        return `${num}`.replace(/0+$/g, '')
            .replace(/\.+$/g, '');
    },
};
